/* Utils */
import {generateAsyncActionCreators} from '../core/reduxUtils'
import {generateFeatureToggleNamesParamString} from '../../modules/feature-toggle/featureToggleUtils'

const getMobileHomePageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_MOBILE_HOME_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDesktopHomePageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_HOME_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getMobileSearchFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_MOBILE_SEARCH_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDesktopSearchFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_SEARCH_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getMobileTagPageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_MOBILE_TAG_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDesktopTagPageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_TAG_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getSearchOldFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_SEARCH_OLD_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getMobileCategoryPageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_MOBILE_CATEGORY_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDesktopCategoryPageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_CATEGORY_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getAppFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_APP_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getCampaignFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_CAMPAIGN_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDynamicFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DYNAMIC_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDynamicViewFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DYNAMIC_VIEW_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getStaticFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_STATIC_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getBrandFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_BRAND_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getMobileProductDetailFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_MOBILE_PRODUCT_DETAIL_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getDesktopProductDetailFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_PRODUCT_DETAIL_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getProductCommentFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_PRODUCT_COMMENT_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getProductQnaFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_PRODUCT_QNA_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getAuthorsFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_AUTHORS_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getMerchantPageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_MERCHANT_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const getNotFoundPageFeatureTogglesActionCreators = generateAsyncActionCreators(
  'GET_NOT_FOUND_PAGE_FEATURE_TOGGLES',
  (featureToggleNames, params) => ({
    params: {
      name: generateFeatureToggleNamesParamString(featureToggleNames),
      ...params,
    },
  })
)

const actionCreators = {
  getAppFeatureToggles: {
    ...getAppFeatureTogglesActionCreators,
  },

  getDesktopHomePageFeatureToggles: {
    ...getDesktopHomePageFeatureTogglesActionCreators,
  },

  getMobileHomePageFeatureToggles: {
    ...getMobileHomePageFeatureTogglesActionCreators,
  },

  getMobileCategoryPageFeatureToggles: {
    ...getMobileCategoryPageFeatureTogglesActionCreators,
  },

  getDesktopCategoryPageFeatureToggles: {
    ...getDesktopCategoryPageFeatureTogglesActionCreators,
  },

  getMobileSearchFeatureToggles: {
    ...getMobileSearchFeatureTogglesActionCreators,
  },

  getDesktopSearchFeatureToggles: {
    ...getDesktopSearchFeatureTogglesActionCreators,
  },

  getDesktopTagPageFeatureToggles: {
    ...getDesktopTagPageFeatureTogglesActionCreators,
  },

  getMobileTagPageFeatureToggles: {
    ...getMobileTagPageFeatureTogglesActionCreators,
  },

  getCampaignFeatureToggles: {
    ...getCampaignFeatureTogglesActionCreators,
  },

  getDynamicFeatureToggles: {
    ...getDynamicFeatureTogglesActionCreators,
  },

  getDynamicViewFeatureToggles: {
    ...getDynamicViewFeatureTogglesActionCreators,
  },

  getStaticFeatureToggles: {
    ...getStaticFeatureTogglesActionCreators,
  },

  getBrandFeatureToggles: {
    ...getBrandFeatureTogglesActionCreators,
  },

  getMobileProductDetailFeatureToggles: {
    ...getMobileProductDetailFeatureTogglesActionCreators,
  },

  getDesktopProductDetailFeatureToggles: {
    ...getDesktopProductDetailFeatureTogglesActionCreators,
  },

  getProductCommentFeatureToggles: {
    ...getProductCommentFeatureTogglesActionCreators,
  },

  getProductQnaFeatureToggles: {
    ...getProductQnaFeatureTogglesActionCreators,
  },

  getAuthorsFeatureToggles: {
    ...getAuthorsFeatureTogglesActionCreators,
  },

  getMerchantPageFeatureToggles: {
    ...getMerchantPageFeatureTogglesActionCreators,
  },

  getNotFoundPageFeatureToggles: {
    ...getNotFoundPageFeatureTogglesActionCreators,
  }
}

export {
  actionCreators,
  getDesktopHomePageFeatureTogglesActionCreators,
  getMobileHomePageFeatureTogglesActionCreators,
  getMobileSearchFeatureTogglesActionCreators,
  getDesktopSearchFeatureTogglesActionCreators,
  getMobileCategoryPageFeatureTogglesActionCreators,
  getDesktopCategoryPageFeatureTogglesActionCreators,
  getAppFeatureTogglesActionCreators,
  getSearchOldFeatureTogglesActionCreators,
  getDesktopTagPageFeatureTogglesActionCreators,
  getMobileTagPageFeatureTogglesActionCreators,
  getCampaignFeatureTogglesActionCreators,
  getDynamicFeatureTogglesActionCreators,
  getDynamicViewFeatureTogglesActionCreators,
  getStaticFeatureTogglesActionCreators,
  getBrandFeatureTogglesActionCreators,
  getMobileProductDetailFeatureTogglesActionCreators,
  getDesktopProductDetailFeatureTogglesActionCreators,
  getAuthorsFeatureTogglesActionCreators,
  getMerchantPageFeatureTogglesActionCreators,
  getProductQnaFeatureTogglesActionCreators,
  getProductCommentFeatureTogglesActionCreators,
  getNotFoundPageFeatureTogglesActionCreators
}
